import {
    Component, ContentChild, ContentChildren,
    HostListener, Input, QueryList, TemplateRef,
} from "@angular/core";
import { BooleanAttribute } from "@hex/angular/decorators";
import { Subject } from "rxjs";
import { CommonFieldManagerDirective } from "../field-manager.directive";

@Component({
    selector: "common-field-toggle",
    templateUrl: "./field-toggle.component.html",
})
export class ToggleFieldComponent {
    @ContentChild(TemplateRef,  {static: false}) public templateRef: TemplateRef<any>;

    @ContentChildren(CommonFieldManagerDirective, { descendants: true })
    public fields: QueryList<CommonFieldManagerDirective>;

    @Input()
    @BooleanAttribute()
    public set startsVisible(value: boolean) {
        this.isActivated = value;
    }

    public set isActivated(value: boolean) {
        this._isActivated = value;
        if (!this.isActivated) {
            this.fields.forEach((field) => {
                field.resetState();
            });
        }
    }

    public get isActivated(): boolean {
        return this._isActivated;
    }

    private _isActivated = false;

    public isDisabled = false;

    public fieldTouched$ = new Subject();

    @HostListener("click", ["$event"])
    public onClick(e): void {
        this.fieldTouched$.next();
    }
}
